import React from "react";
import { createPortal } from "react-dom";
import { FaExclamationTriangle } from "react-icons/fa";

const DeactivateClinicModal = ({
  clinic,
  onClose,
  onConfirm,
  isSubmitting,
}) => {
  if (!clinic) return null;

  return createPortal(
    <div
      className="modal-overlay"
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0, 0, 0, 0.45)",
        zIndex: 1070,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "16px",
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          backgroundColor: "#FFFFFF",
          borderRadius: "12px",
          width: "520px",
          maxWidth: "100%",
          boxShadow: "0 20px 60px rgba(0, 0, 0, 0.18)",
          overflow: "hidden",
          fontFamily: "Poppins, sans-serif",
        }}
      >
        <div
          style={{
            padding: "20px 24px 0",
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
          }}
        >
          <h3
            style={{
              margin: 0,
              fontSize: "18px",
              fontWeight: 700,
              color: "#111111",
              paddingRight: "12px",
            }}
          >
            Deactivate Clinic
          </h3>
          <div
            style={{
              width: "36px",
              height: "36px",
              borderRadius: "50%",
              backgroundColor: "#FEF2F2",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <FaExclamationTriangle size={16} color="#EF4444" />
          </div>
        </div>

        <div style={{ padding: "16px 24px 24px" }}>
          <p
            style={{
              margin: "0 0 24px 0",
              fontSize: "14px",
              color: "#333333",
              lineHeight: 1.6,
            }}
          >
            This will deactivate <strong>{clinic.name}</strong> and remove it
            from active registry operations. Existing patients and users will
            remain visible for historical review.
          </p>

          <div style={{ display: "flex", gap: "12px" }}>
            <button
              type="button"
              onClick={onClose}
              disabled={isSubmitting}
              style={{
                flex: 1,
                backgroundColor: "#FFFFFF",
                color: "#333333",
                border: "1px solid #D1D5DB",
                borderRadius: "8px",
                padding: "12px 20px",
                fontSize: "14px",
                fontWeight: 600,
                cursor: isSubmitting ? "not-allowed" : "pointer",
              }}
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={onConfirm}
              disabled={isSubmitting}
              style={{
                flex: 1,
                backgroundColor: "#EF4444",
                color: "#FFFFFF",
                border: "none",
                borderRadius: "8px",
                padding: "12px 20px",
                fontSize: "14px",
                fontWeight: 600,
                cursor: isSubmitting ? "not-allowed" : "pointer",
                opacity: isSubmitting ? 0.7 : 1,
              }}
            >
              {isSubmitting ? "Deactivating..." : "Deactivate Clinic"}
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default DeactivateClinicModal;
